import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { t, useStoreLanguage } from "../store-language/i18n.ts";
import { HttpService } from "../../utils/DesigningHttpService.js";
import AppFeedback from "../../components/shared/AppFeedback.tsx";
import { AccountIconButton, AccountDrawer } from "../../components/shared/account/AccountUI.tsx";
import { PlatformAdminIcon } from "../platform-admin/PlatformAdminIcon.tsx";
import { getGuidePath } from "./guidePaths.ts";
import "../platform-admin/platform-admin-tokens.css";
import "./portal-guide.css";

type PageGuide = { title: string; description: string; languageCode: string };
const http = new HttpService();

export default function PortalPageGuide() {
  const language = useStoreLanguage();
  const location = useLocation();
  const path = getGuidePath(location.pathname);
  const [open, setOpen] = useState(false);
  const [resolved, setResolved] = useState<{ path: string; language: string; guide: PageGuide } | null>(null);
  const guide = resolved?.path === path && resolved.language === language ? resolved.guide : null;

  useEffect(function () { setOpen(false); }, [path, language]);
  useEffect(function () {
    const controller = new AbortController();
    setResolved(null);
    http.getResource(`/catalog/guides?path=${encodeURIComponent(path)}`, controller.signal)
      .then(function (result: PageGuide | null | "") {
        if (!controller.signal.aborted && result) setResolved({ path, language, guide: result });
      })
      .catch(function (error: unknown) {
        if (!controller.signal.aborted) {
          void AppFeedback.httpError(error);
        }
      });
    return function () { controller.abort(); };
  }, [path, language]);

  if (!guide) return null;

  const content = (
    <article
      className="portal-guide__content"
      lang={guide.languageCode}
      dir={guide.languageCode === "en" ? "ltr" : "rtl"}
    >
      <h2>{guide.title}</h2>
      <div>{guide.description}</div>
    </article>
  );

  return (
    <span className="portal-guide">
      <AccountIconButton
        label={t("راهنمای صفحه")}
        type="text"
        icon={<PlatformAdminIcon name="guides" size={22} />}
        onClick={function () { setOpen(true); }}
        aria-expanded={open}
        disabled={open}
      />
      <AccountDrawer
        title={t("راهنمای صفحه")}
        open={open}
        placement="left"
        onClose={function () { setOpen(false); }}
        wide
      >
        {content}
      </AccountDrawer>
    </span>
  );
}
